export default __webpack_public_path__ + "static/media/femimed_background2_mobile.c00c97eb.webp";